import { ContentSection, PageWrap } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { LandingPageMarketingCardDto } from 'cpes-common';
import {
    MediaTeaser as MediaTeaserShared,
    openInNewWindow,
    useAnalyticsActionTracker,
    MarketingCardLoadingPlaceholder,
} from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useTranslation } from 'react-i18next';

const MarketingCards: React.FC<{ cards: Array<LandingPageMarketingCardDto> | undefined }> = ({ cards }) => {
    const { onAction } = useAnalyticsActionTracker('onClickMarketingCard');
    if (!cards) {
        return null;
    }

    return (
        <ContentSection>
            {cards.map((card, index) => {
                const cardTitle = card?.title || '';
                return (
                    <PageWrap size={'medium'} key={index}>
                        <MediaTeaserShared
                            title={cardTitle}
                            imageUrl={card?.image.href || ''}
                            pretitle={card?.pretitle}
                            text={<p dangerouslySetInnerHTML={{ __html: card?.text as string }} />}
                            buttonLabel={card?.buttonLabel}
                            clickHandler={e => {
                                onAction(cardTitle);
                                openInNewWindow(card?.buttonUrl)(e);
                            }}
                            reversed={index % 2 === 1}
                        />
                    </PageWrap>
                );
            })}
        </ContentSection>
    );
};

const MarketingCardsWithWrappers = withLoadingAndNoConnectionHandler(MarketingCards);

export const LandingPageMarketingCards: React.FC = () => {
    const { t: cms } = useTranslation('landing-page-marketing-cards');
    const landingPageMarketingCards: LandingPageMarketingCardDto[] = [].concat(cms('cards', { returnObjects: true }));

    return (
        <MarketingCardsWithWrappers
            isLoading={false}
            hasError={false}
            cards={landingPageMarketingCards}
            loadingPlaceholder={<MarketingCardLoadingPlaceholder />}
        />
    );
};
